// extracted by mini-css-extract-plugin
module.exports = {"entering":"animation-slideUp-module--entering--3fA1j","entered":"animation-slideUp-module--entered--2AGB8","exiting":"animation-slideUp-module--exiting--1G7F7"};